import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, CONTACT } from "../../lib/content";

const links = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Our Work", href: "#work" },
  { label: "Before/After", href: "#before-after" },
  { label: "Reviews", href: "#reviews" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-md border-b border-gold/20 py-2" : "bg-transparent py-4"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img src={LOGO_URL} alt="Everett - Sam's Treescape" className="h-12 md:h-14 w-auto" />
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[\s/]/g, "-")}`}
              className="text-sm uppercase tracking-widest text-gray-300 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${CONTACT.ownerPhone}`}
            data-testid="nav-call-button"
            className="flex items-center gap-2 text-gold hover:text-gold-light transition-colors"
          >
            <Phone size={16} /> <span className="font-semibold">{CONTACT.ownerPhone}</span>
          </a>
          <a
            href="#estimate"
            data-testid="nav-estimate-button"
            className="bg-gold text-black font-bold px-6 py-3 rounded-sm hover:bg-gold-light transition-colors uppercase tracking-widest text-xs"
          >
            Free Estimate
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-gold"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 border-t border-gold/20 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-widest text-gray-200 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#estimate"
            onClick={() => setOpen(false)}
            data-testid="mobile-estimate-button"
            className="bg-gold text-black text-center font-bold px-6 py-3 rounded-sm uppercase tracking-widest text-xs"
          >
            Free Estimate
          </a>
        </div>
      )}
    </header>
  );
};
